import constantsReducer from './constantsReducer';
import apiCacheReducer from './apiCacheReducer';

const reducers = {
    constants: constantsReducer,
    apiCache: apiCacheReducer,
};

export default reducers;